<template>
 <div class="questions-container" v-if="questions.length">
    <div v-for="question in this.questions" :key="question.id" class="question-wrapper">
      <div class="question-content" :style="questionStyleMap[question.id]">
        <div class="q-main-content">
          <div class="q-header">
            <!-- <div class="q-id"> {{ question.question_type }} </div> -->
            <div class="q-id" :title="question.id" :class="[changeQName(question), { blackNWhite: isExcluded(question) }]" ></div>
            <div class="q-description"> {{ question.description }}</div>
            <div class="q-controls">
              <div class="q-answer">
                <Multiselect
                v-if="question.question_type === 'QUALITATIVE'"
                v-model="valueMap[question.id]"
                :options="getOptionsForQuestion(question)"
                track-by="answer_color" label="text" placeholder="" :searchable="false"
                @blur="updateValue(question.id)"
                :disabled="isReadOnly"
                >
                <template #singleLabel="{ option }"><div class="option-container"><span class="color-dot" :style="{ backgroundColor: getColorForValue(option.answer_color) }"></span></div></template>
                <template #option="{ option }"><div class="option-container"><span class="color-dot" :style="{ backgroundColor: getColorForValue(option.answer_color) }"></span></div></template>
              </Multiselect>
              <button
              v-if="formulaMap[question.id] && !isReadOnly && formulaFlag"
              title="Récupérer la valeur automatique"
              @click="resetFormulaValue(question)"
              >
              <i class="bi bi-arrow-counterclockwise"></i>
              </button>
              <input
              v-if="['QUANTITATIVE-VALUE', 'FORMULA'].includes(question.question_type)"
              type="number" v-model="valueMap[question.id]" step="any"
              @blur="updateValue(question.id)" class="question-input-number"
              :disabled="isReadOnly"
              :title="this.tagValues[question.tag]"
              :class="{ locked: formulaMap[question.id], red: formulaFlag }"
              />
            </div>
            <div class="q-actions">
            <input type="checkbox" class="checkbox-custom" id="checkbox" v-if="question.question_type !== 'QUALITATIVE'" :disabled="isReadOnly" title="Question non applicable - fournir un justificatif" @change="handleCheckbox(question.id, $event.target.checked)" :checked="isChecked(question.id)"/>
            </div>
            <div class="q-actions">
              <button @click="toggleRemark(question.id)" class="remark-toggle-btn" title="Afficher/Cacher les remarques" :disabled="isReadOnly">
                <i class="bi bi-chat-left-text-fill"></i>
              </button>
            </div>
          </div>
          </div>
          <div class="q-sub-details">
            <div class="q-help" v-if="!isEvaluationView"><h3>Aide</h3><p>{{ question.help_text || 'Aucune' }}</p></div>
            <div class="q-justification" :disabled="isReadOnly || !isEvaluationView" :class="{ locked: isReadOnly}">
              <h3>Justificatif à fournir</h3>
              <p>{{ question.justification || 'Pas de justificatif spécifique demandé. Le dépôt du rapport SméO vaut pour engagement. Selon nécessité, des explications pourraient être demandées ultérieurement.' }} <label :for="'file-input-' + question.id" class="btn btn-icon">
                  <i class="bi bi-folder-plus"></i>
                </label>
                <input v-if="!isReadOnly" :id="'file-input-' + question.id" type="file" multiple hidden @change.prevent="uploadFile(question)" accept=".dwg,.word,.docx,.webp,.pdf,.jpg,.jpeg,.png,.lesosai,.xlsx,.xlsm,.3D,.zip"/></p>
                <div v-for="file in getFilesForQuestion(question.id)" :key="file.question_id">
                  <div @click.prevent="openFiles(file)" class='files-selection' :class="{ link: isFileOpened(file) }"> {{ formatDate(file.timestamp) }} | {{ file.name }} <span v-if="!isReadOnly" @click.stop="deleteFile(file)" class="btn btn-icon"><i class="bi bi-trash3-fill"></i></span></div>
                </div>
            </div>
            <div class="q-documentation" v-if="!isEvaluationView"><h3>Documentation</h3><p class="q-documentation-text" v-html="htmlContent(question.documentation)"></p></div>
            <div v-if="legendItems.length && !isEvaluationView" class="legend-container">
              <h3>Légende</h3>
              <div class="legend-items">
                <!-- Working v-if even tho it shouldn't (question_type =/= evaluation_type) -->
                <div v-for="item in legendItems" :key="item.value" class="legend-item">
                    <span v-if="question.question_type === 'QUALITATIVE'" class="color-dot-legend" :style="{ backgroundColor: getColorForValue(item.value) }"></span>
                    <span v-if="question.question_type === 'QUALITATIVE'">{{ item.meaning }}</span>
                    <span v-if="(question.question_type === 'QUANTITATIVE-VALUE' || question.question_type === 'FORMULA')&& item.sign.length >= 2" class="color-dot-legend" :style="{ backgroundColor: getColorForValue(item.value2) }"></span>
                    <span v-if="question.question_type === 'QUANTITATIVE-VALUE' || question.question_type === 'FORMULA'"> {{translateSign(item.sign)}} {{ item.value }}</span>
                </div>
              </div>
            </div>
            <div v-if="isEvaluationView" class="legend-container">
              <h3>Évaluation</h3>
              <div class="legend-items">
                <Multiselect
                  v-model="evalCriteriaMap[question.criteria_id]"
                  :options="getEvaluationOptions"
                  track-by="value" label="text" placeholder="" :searchable="false"
                  @blur="updateValidation(question, evalCriteriaMap[question.criteria_id])"
                  >
                  <template #option="{ option }">
                      <span>{{ option.value }}</span>
                  </template>
                  <template #singleLabel="{ option }">
                      <span>{{ option.value }}</span>
                  </template>
                </Multiselect>
              </div>
            </div>
            <div class="remark-container" v-if="isEvaluationView">
              <textarea
                placeholder="Remarques évaluation..."
                v-model="evalCommentMap[question.criteria_id]"
                class="question-remarques-textarea"
                @blur="updateValidationComment(question, evalCommentMap[question.criteria_id])"
              ></textarea>
            </div>
            <div class="remark-container" v-if="remarksVisibility[question.id] || ((isEvaluationView) && commentMap[question.id])">
              <h3>Commentaire MO</h3>
              <textarea
                placeholder="Remarques..."
                v-model="commentMap[question.id]"
                @blur="updateValue(question.id)"
                :disabled="isReadOnly"
                class="question-remarques-textarea"
              ></textarea>
            </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters } from "vuex"
import '../../assets/styles/multiselect.css'
import Multiselect from "vue-multiselect"

export default {
  name: "CriteriaQuestionDisplay",
  props: {
    questions : {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      resultMap: {},
      commentMap:{},
      valueMap: {},
      remarksVisibility: {},
      formulaMap : {},
      isInitialized : false,
      evalCommentMap: {},
      evalCriteriaMap: {},
      levelColorValues: {
        0: 'var(--zero-color)',
        1: 'var(--one-color)',
        2: 'var(--two-color)',
        3: 'var(--three-color)',
        66: 'var(--sixsix-color)',
        77: 'var(--sevenseven-color)',
        99: 'var(--ninenine-color)',
      },
      signValues: {
        "lteq":"Plus petit ou égal à",
        "lt":"Plus petit que",
        "gteq":"Plus grand ou égal à",
        "gt":"Plus grand que",
      },
      formulaFlag : false,
      visitedFiles: [],
      usedLink:false,
      };
  },
  mounted() {
    this.syncLocalStateWithAnswers()
    /*  let answer = 2
    this.userResults = this.getAnswerModel(answer) */
  },
  computed: {
    ...mapState("project", [/* "answerQ",  */"projectData","selectedProject", "answerQTest", "evaluationCriteriaColor", "evaluationQColor", "selectedQuestionId", "questionTree","filterBlackQuestionsActive","filterUnAnsweredQuestionsActive", "criteriaEvaluation", "files", "file", "roles", "tagValues", "loading"]),
    ...mapGetters("project", ["renderedMarkdown", "readOnlyProject", "isEvaluationView", "getEvaluationOptions", "getEvaluationForCriteria", "filterActiveProject"]),
    ...mapGetters("referential", ["formatDate"]),

    isReadOnly(){
      return this.filterActiveProject.status != 'EDITING' || !this.filterActiveProject.PC
      // return !this.roles
    },
    /* filteredQuestions() {
      if (this.filterBlackQuestionsActive) {
        return this.questions.filter(question => {
          const hasQuantitativeMatch = question.question_limits && 
          question.question_limits['0'] && 
          question.question_limits['0'].limit.length > 0;
          
          const hasQualitativeMatch = question.question_values && 
          question.question_values['0']
          //console.log("FILTER :",hasQualitativeMatch,"|||||\n", hasQuantitativeMatch)
          return hasQuantitativeMatch || hasQualitativeMatch;
        });
      }
      if(this.filterUnAnsweredQuestionsActive){
        return (this.questions || []).filter(q => {
          const ans = this.answerQTest.filter(a => a.question_id === q.id);
          return !!ans && (ans.answer_value === null || ans.answer_color === 66)
        })
      }
      return this.questions;
    }, */
    

  legendItems() {
      if (!this.questions || this.questions.length === 0) return [];
      const qualitativeQuestion = this.questions.find(q => q.question_type === 'QUALITATIVE' && q.question_values);
      const quantitativeQuestion = this.questions.find(q =>/*  q.question_type === 'QUANTITATIVE-VALUE' && */ Object.values(q.question_limits).some(limit => !isNaN(limit.limit) && limit.limit !== ""));
      const formulaQuestion = this.questions.find(q => /* q.question_type === 'FORMULA' &&  */Object.values(q.question_limits).some(limit => isNaN(limit.limit) && limit.limit !== ""));
      if (!qualitativeQuestion && !quantitativeQuestion && !formulaQuestion) return [];
      if(qualitativeQuestion){
        return Object.keys(qualitativeQuestion.question_values).map(key => {
          const valueData = qualitativeQuestion.question_values[key];
          return {
            value: parseInt(key, 10),
            text: valueData.possible_text,
            meaning: valueData.meaning
          }
        });
      }else if(quantitativeQuestion){
        return Object.entries(quantitativeQuestion.question_limits)
        .filter(([,valueData]) => valueData.limit !== "" && valueData.sign !== "" /* && !isNaN(valueData.limit) */)
        .map(([key,valueData]) => {
          return {
            value2: parseInt(key, 10),
            sign: valueData.sign,
            value: valueData.limit
          }
        });

        /* TO DO  */
      }else if (formulaQuestion){
        return Object.entries(formulaQuestion.question_limits)
      .filter(([,valueData]) => valueData.limit !== "" && valueData.sign !== "")
      .map(([key,valueData]) => {
        ////console.log("filtered valueData", valueData, "this.valueData(tagValues)", this.tagValues[valueData.limit]);
        let tagResult = this.tagValues[valueData.limit]
        ////console.log("tagResultOffi = ", tagResult + " meaning ? ", valueData.meaning )
        //Verify, not sure it implies every cases
        if(tagResult != String && isNaN(tagResult)){
          tagResult
          ////console.log("tagResult8", tagResult)
        }else {
          tagResult *= valueData.factor
          ////console.log("tagResult w/factor : ", valueData.limit + " = " + tagResult + " * " + valueData.factor)
        }
        return {
          value2: parseInt(key, 10),
          sign: valueData.sign,
          value: valueData.limit + " = " + tagResult
        };
        })
      }
      return [];
    },

    existingAnswersMap(){
      const map = {}
      if(!Array.isArray(this.answerQTest) || this.answerQTest.length === 0)return map
      for (const answer of this.answerQTest){
        /* if(answer.calculated_result === null || answer.calculated_result === undefined){
          map[answer.question_id] = {
            remaques : answer.comment,
            calculated: 99
          }
        } */
       ////console.log("answerQ = ",answer)
        map[answer.question_id] = {
          /* result: answer.user_result, */
          answer_value : answer.answer_value,
          user_value: answer.user_value, 
          user_color: answer.user_color,
          remarques: answer.comment || "",
          answer_color: answer.answer_color,
          forced_result: answer.forced_result || false,
        }
      }
      return map
    },

    questionStyleMap(){
      const style = {};

      if(!this.answerQTest || this.answerQTest.length >0){
        return style;
      }
      this.answerQTest.forEach(a =>{
        const colorCode = a.answer_color;

        if(colorCode !== null && this.levelColorValues[colorCode]){
          style[a.question_id] = {
            '--project-border-color': this.levelColorValues[colorCode]
          };
        }else if(colorCode === null){
          ////console.log("BIG TROUBLE, jk")
          style[a.question_id] = {
            '--project-border-color': 'var(--sixsix-color)'
          }
        }
      });
      return style;
    },

    optionsMap() {
      const map = {}
      const sourceQuestions = this.questionTree.length ? this.questionTree : this.questions

      for (const question of sourceQuestions) {
        if (question && question.question_values) {
          map[question.id] = Object.keys(question.question_values).map(key => ({
            value: parseInt(key, 10),
            text: question.question_values[key].possible_text
          }))
          //console.log("map", map[question.id])
        } else {
          map[question.id] = []
        }
      }
      return map
    },
  },
  watch: {
    existingAnswersMap: {
      handler(newAnswers) {
        if (newAnswers && Object.keys(newAnswers).length > 0) {
          this.syncLocalStateWithAnswers()
          if (!this.isInitialized) {
            //console.log("( Who are you : Les réponses sont arrivées ! Initialisation...", newAnswers)
            this.initializeRemarksVisibility(this.questions)
            this.isInitialized = true
          }
        }
      },
      immediate: true,
      deep: true
    },
    criteriaEvaluation: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.syncEvalComments()
        }
      },
      immediate: true,
      deep: true
    },
    valueMap: {
      handler(newValueMap) {
        ////console.log("Im litteraly getting asked to come and go into this project to retrieve the tags am I not ?", newValueMap)
        //might try to find the reason why it needs the newValueMap to works, I haven't dig into it
        if(newValueMap != ""){
            this.recalculateFormulas();
          }
        },
        deep: true
    },
  },
  components: {
    Multiselect,
  },
  methods: {
    recalculateFormulas() {
        const formulaQuestions = this.questions.filter(q => Object.values(q.question_limits).some(limit => isNaN(limit.limit) && limit.limit !== ""));
        ////console.log("formulaQuestions :",formulaQuestions)
        formulaQuestions.forEach(question => {
            if (question.question_limits) {
              ////console.log(question.question_limits[0])
                Object.values(question.question_limits).forEach(limitData => {
                    if (typeof limitData.limit === 'string' && isNaN(limitData.limit) /* && (this.tagValues.result !== "" ) */) {
                        const payload = {
                            tag: limitData.limit,
                            index: "NaN", 
                        };
                        this.$store.dispatch("project/fetchTagValues", payload);
                    }
                });
            }
        });
    },
    isExcluded(question){
      if(!question)return false;
          const hasQuantitativeMatch = question.question_limits && 
          question.question_limits['0'] && 
          question.question_limits['0'].sign.length > 0 && 
          question.question_limits['0'].limit.length > 0;
          
          const hasQualitativeMatch = question.question_values && 
          question.question_values['0'] && 
          question.question_values['0'].possible_text === "Black";
          return hasQuantitativeMatch || hasQualitativeMatch;
    },
    changeQName(questionId){
      const questionType = questionId.question_type
      if(questionType === "QUALITATIVE"){
          return "bi bi-award-fill";
      }else if(questionType === "QUANTITATIVE-VALUE" || questionType === "FORMULA"){
          return "bi bi-bar-chart-fill";
      }
      return "";
    },

    getMimeTypeFromName(filename){
      const extension = filename.split('.').pop().toLowerCase();
      switch (extension){
        case 'png': return 'image/png';
        case 'jpg':
        case 'jpeg': return 'image/jpeg';
        case 'pdf': return 'application/pdf';
        case 'zip': return 'application/zip';
        case 'dwg': return 'image/vnd.dwg';
        case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        case 'doc': return 'application/msword';
        case 'dxf': return 'image/vnd.dxf';
        case 'ifc': return 'application/x-step';

        /* case 'dxf': return 'application/dxf';
        case 'bld': return 'application/octet-stream'; */
        default : return 'application/octet-stream';
      }
    },

    getFilesForQuestion(questionId) {
      if (!this.files || !Array.isArray(this.files)) {
        return [];
      }
      return this.files.filter(file => file.question_id === questionId);
    },

    isFileOpened(file){
      const selectedFile = file.name + file.timestamp;
      return this.visitedFiles.includes(selectedFile)
    },

    async openFiles(file) {
      const payload = {
        question_id: file.question_id,
        name: file.name,
        timestamp: file.timestamp,
      };
      
      try{
        const originalBlob = await this.$store.dispatch("project/getFile", payload); 
        const mimeType = this.getMimeTypeFromName(file.name);
        const correctedBlob = new Blob([originalBlob], { type: mimeType });
        
        const fileURL = URL.createObjectURL(correctedBlob);

        const link = document.createElement('a');
        link.href = fileURL;
        link.download = file.name;
        link.style.display = 'none';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        const selectedFile = file.name + file.timestamp;
        if(!this.visitedFiles.includes(selectedFile)){
          this.visitedFiles.push(selectedFile)
        }

        setTimeout(() => {
          URL.revokeObjectURL(fileURL);
        }, 100);

      } catch (error) {
        console.error("Erreur lors du téléchargement du fichier :", error);
      }
          
    /* 
      const fileObject = new File([originalBlob], file.name, { type: mimeType });
      const imageURL = URL.createObjectURL(fileObject);

      const viewableTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'text/plain'];

      if (viewableTypes.includes(mimeType)) {
        window.open(imageURL, '_blank');
      } else {
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } */
    },
    async deleteFile(file){
      //console.log("clicked on deleteFile ", file)
      const payload = {
        question_id: file.question_id,
        name: file.name,
        timestamp : file.timestamp,
        project_id : file.project_id,
      };
      await this.$store.dispatch("project/deleteFile", payload);
    },
    async uploadFile(question) {
      //console.log("You're in : ", question)
      const questionId = question.id;
      let fileInput = document.getElementById('file-input-' + questionId)
      if (fileInput && fileInput.files.length > 0) {
        const file = fileInput.files[0];
        /* const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/zip', 'application/vnd.ms-excel']; */
        const maxFileSize = 100 * 1024 * 1024;
        //console.log("file.type : ",file.type);

        /* if(!allowedTypes.includes(file.type)){
          console.warn("type de fichier non autorisé :", file.type)
        } */

        if (file.size>maxFileSize){
          console.warn("taille du fichier trop grande : ", file.size)
        }
        await this.$store.dispatch("project/uploadFile", { questionId, file })
          //console.log("AM I IN THIS.FILES ? ", file)
          this.$store.dispatch("project/getAllFiles")
        //console.log("this.files res ? :", this.files);
      } else {
        console.warn("Aucun fichier sélectionné pour la question :", questionId)
      }
    },


    isChecked(questionId){
      /* this.defaultTag == !this.defaultTag */
      const answer = this.answerQTest.find(a => a.question_id === questionId);
      return !!(answer && (answer?.answer_color === 99 || answer?.user_color === 99));
    },

    handleCheckbox(questionId, checked){
      //console.log("(udpateAnswer)defaultTag ", this.defaultTag)
      const payload = {
        question_id: questionId,
        user_color: checked ? 99 : null
      };
      /* //console.log("(updateAnswer)Checkbox = ",this.isChecked[questionId] + "\nquestionId = ", questionId); */
      //console.log("What are you sending to updateAnswer\nCheckbox :" + checked + "\nValue :" + 99)
      this.$store.dispatch("project/updateAnswer", payload)
    },

    htmlContent(text) {
        if(!text || text.length <= 0) {
        text = "Aucune documentation"
        }
        return this.renderedMarkdown(text)
    },

  /*   getProjectStyle(question) {
    const answer = this.answerQTest.find(a => a.question_id == question.id);{
      if(answer){
      let colorCode = answer.answer_color;
        //console.log("answer___", colorCode + " " + answer.question_id)
          if(colorCode){
            return {
              '--project-border-color': this.levelColorValues[colorCode]
            }
          }else{
            return{
              '--project-border-color': 'var(--ninenine-color)'
            }
          }
        }
      }
    }, */

  /* getMeaningForQuestion(questionId) {
      const question = this.questions.find(q => q.id === questionId)
      if (!question || question.question_type !== 'QUALITATIVE') {
          return ""
      }
      const selectedResult = this.resultMap[questionId]
      if (!selectedResult) {
          return "" 
      }
      const selectedValue = selectedResult.value

      if (question.question_values && question.question_values[selectedValue]) {
          return question.question_values[selectedValue].meaning || ""
      }
      
      return ''
  }, */
    
    toggleRemark(questionId){
      this.remarksVisibility[questionId] = !this.remarksVisibility[questionId]
    },
  
    initializeRemarksVisibility(questionId){
      if(!questionId) return

      const newVisibilityState = {}
      questionId.forEach(question => {
        const hasContent = this.commentMap[question.id] && this.commentMap[question.id].trim().length > 0
        newVisibilityState[question.id] = hasContent
      })
      this.remarksVisibility= newVisibilityState
    },

    async syncLocalStateWithAnswers() {
      if (!this.questions) return
      const newCommentMap = {}
      const newValueMap = {}
      const newFormulaMap = {}

      for (const question of this.questions) {
          const options = this.getOptionsForQuestion(question)
          const existingAnswer = this.existingAnswersMap[question.id]
        if (question.question_type === 'QUALITATIVE' && question.is_evaluated === 0) {
           const userColor = existingAnswer ? existingAnswer.user_color : null;
          
          //if (userColor) {
              const selectedOption = options.find(o => o.answer_color === userColor);
              newValueMap[question.id] = selectedOption || { answer_color: 66, text: 'grey', value: 66 }
          /*}  else {
              newValueMap[question.id] = { answer_color: 77, text: 'white', value: 77 };
          } */

          newCommentMap[question.id] = existingAnswer ? (existingAnswer.remarques || existingAnswer.comment) : "";
          continue; 
      }

          if (existingAnswer) {
              if (question.question_type === 'QUALITATIVE') {
                  const colorToUse = existingAnswer.user_color !== null && existingAnswer.user_color !== undefined 
                      ? existingAnswer.user_color 
                      : existingAnswer.answer_color
                      ////console.log("template => colorToUse :", colorToUse)
                  let selectedOption = options.find(option => option.answer_color === colorToUse)
                  ////console.log("template => selectedOption :", selectedOption)
                  
                  if (!selectedOption) {
                    if(options.length === 1) selectedOption = options[0];
                    else selectedOption = options.find(o => o.answer_color === 66);
                    ////console.log("template => NOT selectedOption === option[] :", options)
                  }
                  
                  newValueMap[question.id] = selectedOption || options.find(o => o.answer_color === 66)
                  ////console.log("template => newValueMap[question.id] :", newValueMap[question.id])
              } else if (question.question_type === 'QUANTITATIVE-VALUE') {
                  const val = (existingAnswer.user_value !== null && existingAnswer.user_value !== undefined) 
                    ? existingAnswer.user_value 
                    : existingAnswer.answer_value;
                    
                  newValueMap[question.id] = val;

              } else if (question.question_type === 'FORMULA') {
                  const val = (existingAnswer.user_value !== null && existingAnswer.user_value !== undefined) 
                    ? existingAnswer.user_value 
                    : existingAnswer.answer_value;
                    
                  newValueMap[question.id] = val;
                  
                  this.formulaFlag = existingAnswer.forced_result
                  
                  if(question.tag){
                    if(this.tagValues[question.tag] === undefined){
                      const payload = { tag: question.tag, index: "NaN" };
                      await this.$store.dispatch("project/fetchTagValues", payload);
                    }
                  }
                  newFormulaMap[question.id] = true
              }
              
              newCommentMap[question.id] = existingAnswer.remarques || existingAnswer.comment
          } else {
              newCommentMap[question.id] = ""
              if (question.question_type === 'QUALITATIVE') {
                  newValueMap[question.id] = options.find(o => o.answer_color === 66)
              }
          }
      }
      this.commentMap = newCommentMap;
      this.valueMap = newValueMap;
      this.formulaMap = newFormulaMap;
    },
    getOptionsForQuestion(question) {
      //locked values for question not evaluated
    /* if (question && question.is_evaluated === 0) {
      //console.log("getOptionsForQuestion", question)
        return [
          { answer_color: 77, text: 'white', value: 77 },
          { answer_color: 99, text: 'blue', value: 99 }
        ];
      } */
     ////console.log("question valueMap is_evaluated ?",question)
      if (!question || !question.question_values) {
        return [
          { answer_color: 66, text: 'grey', value: 66 }, 
          { answer_color: 99, text: 'blue', value: 99 }
        ];
      }

      const selectedValue = this.valueMap[question.id]?.answer_color;
      
      const baseOptions = Object.keys(question.question_values || {}).map(key => ({
              answer_color:  parseInt(key, 10),
              text: question.question_values[key].possible_text,
              value: parseInt(key, 10) 
      }));

      let specialOptions = [
          { answer_color: 99, text: 'blue', value: 99 }
      ];

      const noValueSelected = (selectedValue === undefined || selectedValue === null);

      if (noValueSelected || selectedValue === 66) {
          specialOptions.unshift({ answer_color: 66, text: 'grey', value: 66 });
      }

      const allOptions = [...baseOptions, ...specialOptions];
      return allOptions.map(option => ({
          ...option,
          $isDisabled: (option.answer_color === selectedValue)
      }));
    },
    getColorForValue(value){
    if (value === 0) {
      return this.levelColorValues[0];
    }
    if (value === undefined || value === null) {
      return this.levelColorValues[66];
    }
      return this.levelColorValues[value];
    },
    translateSign(sign){
      return this.signValues[sign];
    },
    updateValue(questionId){
      const question = this.questions.find(q => q.id === questionId);

      if(!question)return

      /* let userResult = null */
      let calculatedResult = null
      let colorResult = null

      //console.log("valueMap: ",this.valueMap[questionId])
      if(question.question_type === 'QUALITATIVE') {
        if(this.valueMap[questionId]){
          //console.log(this.valueMap[question.id], " this.valueMap[question.id]");
          colorResult = this.valueMap[questionId].answer_color
          //console.log(colorResult, "colorResult");
        }
        /* calculatedResult = userResult */
      } else if (question.question_type === 'QUANTITATIVE-VALUE') {
        calculatedResult = this.valueMap[questionId]
        /* calculatedResult = userResult */
      }else if(question.question_type === 'FORMULA'){
        calculatedResult = this.valueMap[questionId]
        //console.log("questionId3 :",questionId)
      if(calculatedResult != this.tagValues[questionId]){
        this.formulaFlag = true
      }else{
        this.formulaFlag = false
      }
      }

      const payload = {
        question_id: questionId,
        user_value: calculatedResult,
        user_color:colorResult,
        comment: this.commentMap[questionId] || ""
      }
      ////console.log("Payload prêt à être envoyé :", payload)
      this.$store.dispatch("project/updateAnswer", payload)
    },
    updateValidation(question, selectedOption) {
      //console.log("updateValidation called with question:", question, "and selectedOption:", selectedOption)
      const criteriaId = question.criteria_id
      if (!criteriaId) return
      const payload = {
        project_id: this.selectedProject,
        criteria_id: criteriaId,
        status: selectedOption.id,
        comment: this.getCriteriaEvaluation(criteriaId).comment || ""
      }
      ////console.log("Payload d'évaluation :", payload)
      this.$store.dispatch("project/updateEvaluation", payload)
    },
    updateValidationComment(question, comment) {
      const criteriaId = question.criteria_id || question.criteriaId;
      if (!criteriaId) return;

      const payload = {
        project_id: this.selectedProject,
        criteria_id: criteriaId,
        comment: comment
      };
      this.$store.dispatch("project/updateEvaluation", payload)
    },
    getCriteriaEvaluation(criteriaId) {
        return this.getEvaluationForCriteria(criteriaId) || {}
    },
    syncEvalComments() {
      if (!this.questions) return;
      for (const question of this.questions) {
        const evalObj = this.getCriteriaEvaluation(question.criteria_id) || {}
        if (evalObj && evalObj.id !== "NONE") {
            this.evalCommentMap[question.criteria_id] = evalObj.comment || "";
            const selectedOption = this.getEvaluationOptions.find(opt => opt.id === evalObj.status);
            this.evalCriteriaMap[question.criteria_id] = selectedOption || null;
            //selectedOption || 66 ?
        }
        // //console.log("Evaluation found? :", question.criteria_id, evalObj)
        // this.$set(this.evalCommentMap, question.criteriaId, evalObj.comment || "");
      }
      // //console.log("comment synched : ", this.evalCommentMap)
      // //console.log("evaluation synched : ", this.evalCriteriaMap)
    },
    resetFormulaValue(question){
      //console.log("resetFormulaValue called for question:", question)
      const payload = {
      question_id: question.id,
      user_value: null,
      comment: this.commentMap[question.id] || "",
      tag: question.tag
    }
    if(this.formulaFlag) this.formulaFlag = false;
    this.$store.dispatch("project/updateAnswer", payload)
    const taggy = this.tagValues[payload.tag]
    if(taggy){
      this.valueMap[question.id] = taggy
    }
    //console.log("payload formula value",payload)
    }
},
 
}


</script>

<style scoped>

/* .italique{
  font-style: italic;
} */

.q-answer .locked{
  background-color: #89898966;
  opacity:0.7;
}

.locked .locked {
    opacity: 1; 
}

.legend-container {
  padding: 8px 15px;
  background-color: #f9f9f9;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  /* max-width: -moz-fit-content;
  margin: 0 0 20px 20px;
  max-width: fit-content; */
}

.legend-container h3 {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 12px 0;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.legend-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  text-wrap: wrap;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4B5563;
}

.color-dot-legend {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* .question-wrapper {
  margin: 0 0 10px 20px;
} */
.question-content {
/*   display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto; */
  gap: 0 20px;
  padding: 15px;
  margin-left: 2vw;
  /* background: #fdfdfd;
  border-radius: var(--border-radius);
  border-left: 3px solid var(--project-border-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); */
}

.q-main-content {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.q-header {
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
}

.q-id {
  display: flex;
  justify-content: center;
  align-items: center;   
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  /* text-align: center; */
  background: #f3f3f3;
  font-weight: 700;
  font-size: 1em;
  color: var(--text-color);
}

.q-id.blackNWhite{
  background: black;
  color: white;
}

.q-description {
  font-weight: 500;
  color: #333;
  font-size: 15px;
  flex-grow: 1;
  min-width: 0;
}
.q-sub-details {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  padding-top: 15px;
  border-top: 1px solid var(--border-color);
  font-size: 13px;
  color: #666;
}

.q-sub-details h3 {
  font-size: 11px;
  color: #555;
  text-transform: uppercase;
  margin-bottom: 4px;
  text-decoration: underline;
}
.q-sub-details p { margin: 0; }

.q-sub-details > .q-help{
  flex: 0 1 30%; 
}

.q-sub-details > .q-justification{
  flex: 1 1 30%; 
}

.q-sub-details > .q-documentation,
.q-sub-details > .legend-container,
.q-sub-details > .remark-container {
  flex: 1 1 30%; 
}

@media only screen and (min-width:1000px) and (max-width: 1400px) {
  .q-sub-details {
  display: flex;
  flex-wrap: wrap;
}

/*   .q-sub-details > .q-help,
.q_sub_details > .q-justification,
.q-sub-details > .q-documentation,
.q-sub-details > .legend-container,
.q-sub-details > .remark-container {
  flex: 1 1 50px; 
} */
}

.q-documentation{
  max-width: 100%;
}

.q-documentation-text{
  text-decoration: underline;
  /* color: #bb1111; */
  font-weight: 500;
  font-size: 13px;
  word-break: break-word;
}

.q-controls {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  display: flex; 
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding-top: 5px;
  flex-shrink: 0;
  margin-left: auto;
}

.q-answer{
  display: flex;
  align-items: center;
}

.q-answer .red{
  opacity: 0.6;
  color: var(--primary-color);
  font-weight: 600;
}

.q-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
:deep(p > p > a) {
  font-size: 13px;
  color: #bb1111;
  text-decoration: underline;
}

:deep(span > b > a) {
  text-decoration: underline;
  color: #bb1111;
  font-weight: 500;
  font-size: medium;
  font-family: var(--font);
}
.question-remarques-textarea {
  width: 100%;
  min-height: 80px;
  resize: vertical;
  padding: 8px 12px;
  font-family: var(--font);
  font-size: 14px;
  /* resize: vertical;
  transition: var(--transition); */
}
.question-remarques-textarea:focus {
  box-shadow: 0 0 0 3px var(--shadow-light);
}

:deep(.multiselect),
:deep(.multiselect__tags),
:deep(.multiselect__option),
:deep(.multiselect__option:hover) {
  cursor: pointer;
}

:deep(.multiselect__content-wrapper){
/* max-width: 150px;
min-width: 150px; */
overflow:hidden;
background-color: transparent;
border: none;
}
:deep(.multiselect__tags) {
min-height: 42px;

padding: 0;
background-color: transparent;
display: flex;
align-items: center;
transition: var(--transition);
}

/* 
:deep(.multiselect__tags:hover),
:deep(.multiselect--active .multiselect__tags) {
border-color: var(--primary-color);
} */

:deep(.multiselect--active .multiselect__tags) {
box-shadow: 0 0 0 3px var(--shadow-light);
}

:deep(.multiselect__single) {
display: flex;
align-items: center;
height: 100%;
padding: 0;
margin: 0;
background: transparent;
}

:deep(.multiselect__select) {
  display: none;
}

:deep(.multiselect__option) {
  padding: 0;
  cursor: pointer;
}

/* :deep(.multiselect__option--highlight) {
  background-color: var(--hover-bg);
  width: 200%;
} */

/* :deep(.multiselect__option--selected .multiselect__option--highlight::after,.multiselect__option--selected .multiselect__option--highlight, .multiselect__option--highlight, .multiselect__option--selected) {
  background-color: none;
  background: none;
  color: none;
} */

/* :deep(.multiselect__option--selected) {
  background-color: var(--hover-bg);
} */

:deep(.multiselect__option--highlight) .color-dot { transform: scale(1.2); }
.option-container { display: flex; justify-content: center; align-items: center; height: 40px; min-width:2vw;}
.color-dot { width: 22px; height: 22px; border-radius: 50%; border: 0.1px solid #4B5563;}

.remark-toggle-btn {
  width: 32px; height: 32px; border: 1px solid transparent; background: transparent; color: #aaa;
  border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center;
  padding: 0; transition: var(--transition);
}
.remark-toggle-btn i { font-size: 18px; color: #555;}
.remark-toggle-btn:hover { background: #f0f0f0; color: #333; }
.remark-container {
  flex: 0 0 300px; 
  width: 300px;
}

.question-input-number {
  width: 80px; 
  height: 40px; 
  padding: 5px 8px;
  font-family: var(--font);
  font-size: 14px;
  text-align: center; 
  color: var(--text-color);
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius); 
  outline: none;
  box-sizing: border-box;
  transition: var(--transition);
  appearance: textfield;
  -moz-appearance: textfield;
}

.question-input-number::-webkit-outer-spin-button,
.question-input-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.question-input-number:focus {
  /* border-color: var(--primary-color); */
  box-shadow: 0 0 0 3px var(--shadow-light); 
}

.btn-icon {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 18px;
    padding: 0;
    margin: 0 2px;
    background-color: var(--hover-bg);
    color: var(--text-color);
}

.btn-icon:hover {
    color: var(--primary-color);
}
.files-selection {
  text-decoration: underline;
}
.files-selection:hover{
  /* transform: translateX(5px); */
  font-weight: 600;
  cursor:pointer;
}
.link {
  color: blue
}
.checkbox-custom{
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 25px;
}
.checkbox-custom:checked{
  background-color: var(--ninenine-color);
}
</style>